import React from 'react';
import { ACTIVITY_PERIODS } from './lib/activityFormat';
import { scrollToSection } from './lib/scrollToSection';

export const SECTION_LINKS = [
  { key: 'overview', label: 'Overview' },
  { key: 'exams', label: 'Exam practice' },
  { key: 'cases', label: 'Cases' },
  { key: 'applications', label: 'Applications' },
  { key: 'writing', label: 'Writing' },
  { key: 'quizzes', label: 'Quiz generator' },
  { key: 'interviews', label: 'Interviews' },
];

/**
 * The bar that stays at the top of the Activity tab: a button per section,
 * calling `onJump(key)` (by default just scrolling there; the panel also
 * records it in the URL), and the period every section reads. Sections
 * carry scroll-margin-top so the bar does not cover their titles.
 */
const ActivitySubnav = ({ period, onPeriodChange, onJump = scrollToSection }) => (
  <div className="td-act-subnav">
    <nav className="td-act-subnav__jump" aria-label="Sections">
      {SECTION_LINKS.map((s) => (
        <button key={s.key} type="button" onClick={() => onJump(s.key)}>{s.label}</button>
      ))}
    </nav>
    <div className="td-act-toggle" role="group" aria-label="Period">
      {ACTIVITY_PERIODS.map((p) => (
        <button
          key={p.value}
          type="button"
          aria-pressed={period === p.value}
          onClick={() => onPeriodChange(p.value)}
        >
          {p.label}
        </button>
      ))}
    </div>
  </div>
);

export default ActivitySubnav;
